import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { StarFilledIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/search-common';

import 'css!./__styles__/Ratings';

type Props = {
  averageFiveStarRating: number;
  ratingCount?: number;
};

class Ratings extends React.Component<Props> {
  render() {
    const { averageFiveStarRating, ratingCount } = this.props;

    return (
      <div
        className="rc-Ratings horizontal-box"
        role="img"
        aria-roledescription="rating"
        aria-label={
          ratingCount
            ? _t('Rated #{averageFiveStarRating} out of 5 stars. #{ratingCount} reviews', {
                averageFiveStarRating,
                ratingCount,
              })
            : _t('Rated #{averageFiveStarRating} out of 5 stars', { averageFiveStarRating })
        }
      >
        <div className="ratings-icon" aria-hidden="true">
          <StarFilledIcon size="small" color="default" />
        </div>
        <span className="ratings-text" aria-hidden="true">
          {averageFiveStarRating}
        </span>
        {ratingCount ? (
          <span className="ratings-count" aria-hidden="true">
            <FormattedMessage message="({count})" count={ratingCount.toLocaleString()} />
          </span>
        ) : null}
      </div>
    );
  }
}

export default Ratings;
